import axios from "axios";
import { getAuthToken, getMfaToken } from '../helpers/localStorage';

export const TCNCP_API = process.env.REACT_APP_TCNCP_API;

const Axios = axios.create({
  baseURL: TCNCP_API,
});

Axios.interceptors.request.use(function (config) {
  const token = getAuthToken();
  const mfaToken = getMfaToken();

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  else if (mfaToken) {
    config.headers["Authorization"] = `Bearer ${mfaToken}`;
  }

  return config;
});


export default Axios;
